import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "store";
import Spinner from "components/atoms/Spinner";
import { AGREEMENT_VERSION, GUIDE_VERSION } from "common/constants";

interface PageGuard {
  requireAuth?: boolean;
  requireAdmin?: boolean;
  requireAgreement?: boolean;
  requireGuide?: boolean;
}

export const withPageGuard = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  guards: PageGuard
) => {
  return function WithPageGuard(props: P) {
    const navigate = useNavigate();
    const { user, isLoading } = useSelector((state: RootState) => state.user);
    const { agreementVersion, guidedVersion } = user || {};

    useEffect(() => {
      if (isLoading) return;

      // 로그인 체크
      if (guards.requireAuth && !user) {
        navigate("/login");
        return;
      }

      // 관리자 권한 체크
      if (guards.requireAdmin && !user?.roles?.includes("admin")) {
        navigate("/unauthorized");
        return;
      }

      // 약관 동의 체크
      if (guards?.requireAgreement && agreementVersion !== AGREEMENT_VERSION) {
        navigate("/agreements");
        return;
      }

      // 가이드 동의 체크
      if (guards?.requireGuide && guidedVersion !== GUIDE_VERSION) {
        navigate("/agreements");
        return;
      }
    }, [user, isLoading, agreementVersion, guidedVersion, navigate]);

    if (isLoading) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spinner />
        </div>
      );
    }

    return <WrappedComponent {...props} />;
  };
};
